import { render, staticRenderFns } from "./PolicyCheckList.vue?vue&type=template&id=4c2705d2&"
import script from "./PolicyCheckList.vue?vue&type=script&lang=js&"
export * from "./PolicyCheckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports